import React, { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { authAPI } from '../../services/api';
import { Sidebar, MobileHeader } from './Sidebar';

export const DashboardLayout: React.FC = () => {
  const { isAuthenticated, token } = useAuthStore();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Double-check authentication with localStorage as fallback
  const localToken = localStorage.getItem('auth_token');
  const isValidToken = localToken && authAPI.isTokenValid();

  // Consider authenticated if either store says so OR we have a valid token in localStorage
  const effectivelyAuthenticated = isAuthenticated || (isValidToken && token);

  if (!effectivelyAuthenticated && !isValidToken) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-sand-50">
      {/* Mobile Header with hamburger menu */}
      <MobileHeader onMenuClick={() => setMobileMenuOpen(true)} />

      {/* Sidebar - hidden on mobile, visible on desktop */}
      <Sidebar mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />

      {/* Main content - responsive margin */}
      <main className="lg:ml-64 min-h-screen pt-14 lg:pt-0">
        <div className="p-4 sm:p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
